module.exports = "<ul class=\"container\" *ngIf=\"messages\">\n  <li *ngFor=\"let message of messages\">\n    <cat-alert [message]=\"message\"></cat-alert>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-base/components/alerts/alerts.component.html
// module id = ../../../../../src/app/modules/ui-base/components/alerts/alerts.component.html
// module chunks = main